import { logisticsContent } from "./logistics.js";
import { itNis2Content } from "./itNis2.js";
import { telecommunicationsContent } from "./telecommunications.js";
import { energyContent } from "./energy.js";

export const serviceAreas = [
    logisticsContent,
    itNis2Content,
    telecommunicationsContent,
    energyContent
];

export {
    logisticsContent,
    itNis2Content,
    telecommunicationsContent,
    energyContent
};
